// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.84.0/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"2dac9d9783b20a4a328f","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};